<template>
  <div :class="$style.root">
    <div :class="$style.labelContainer">
      <div :class="$style.label">{{$t('pages.press.kit.label')}}</div>
    </div>

    <ul :class="$style.list">
      <li
        v-for="entry in data"
        :key="entry?.id"
        :class="$style.item"
      >
        <SharedPressKitEntriesThumbnailComponent :data="entry" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})
</script>

<style module>
.root {
}

.labelContainer {
  composes: container font-helvetica font-size-small from global;
  margin-bottom: var(--lh, 1em);
}

.label {
}

.list {
  composes: reset-list container--modal from global
}

.item {
  margin-left: var(--unit--default);
  margin-right: var(--unit--default);

  break-inside: avoid;
}

.item:not(:first-of-type) {
  border-top: var(--stroke--default) solid;

  margin-top: calc(var(--unit--default) / 2);
  padding-top: calc(var(--unit--default) / 2);
}

</style>
